<template>
  <el-dialog
    class="number-of-treatment-wrapper"
    title="参数编号"
    :visible.sync="modifyParNumData.isShowDialog"
    :close-on-click-modal="false"
    width="30%"
    :append-to-body="true"
    :modal-append-to-body="false"
  >
    <div class="content">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="modifyParNumForm" label-width="80px"
               class="demo-ruleForm" @submit.native.prevent="">
        <el-form-item label="参数编号" prop="detail_title">
          <el-input
            ref="modifyDetailTitle"
            type="text"
            v-focus
            v-model="ruleForm.detail_title"
            @keydown.native.enter="confirm"
            @input="ruleForm.detail_title = ruleForm.detail_title.replace(/[^\d]/g, '')"
            maxlength="2"
            placeholder="编号范围1到99"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer" style="padding-right: 10px">
      <!--<el-button @click="diagnosisFormData.isShowNumberOfTreatmentDialog = false">取 消</el-button>-->
      <el-button type="primary" @click.prevent="confirm" class="foot-save-btn">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import gql from 'graphql-tag';
  export default {
    
    inject: {
      modifyParNumData: ['modifyParNumData'],
      commonData: ['commonData'],
      hairdressingInfoData: ['hairdressingInfoData'],
    },
      props: {
          parNumsList: {
              default: () => {
                  return [];
              },
          }
      },
    data() {
      const checkDetailTitle = async (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入参数编号'));
        } else if (value === '0') {
          callback(new Error('编号范围1到99'));
        } else {
          const a = await this.checkDetailTitleRepetition(value);
            const b = this.checkDetailTitleRepetitionForLocal(value);
            if (a && b) {
            callback();
          } else {
            callback(new Error('该参数编号已存在'));
          }
        }
      };
      
      return {
        ruleForm: {
          detail_title: '',
        },
        rules: {
          detail_title: [{ validator: checkDetailTitle, trigger: 'change' }],
        },
      };
    },
  
    watch: {
      'modifyParNumData.isShowDialog'(val) {
        if (val) {
            this.ruleForm.detail_title = this.hairdressingInfoData.selectedParNum.number
          this.$nextTick(() => {
            this.$refs.modifyDetailTitle.focus();
          });
        }
      },
    },
    
    methods: {
      confirm() {
        this.$refs.modifyParNumForm.validate((valid) => {
          if (valid) {
            // 操作
            this.modifyParNumData.isShowDialog = false;
            this.hairdressingInfoData.selectedParNum.number = this.ruleForm.detail_title;
            this.modifyCosmetologyTreatDetail();
            this.$refs.modifyParNumForm.resetFields();
              this.$message({
                  type: 'success',
                  message: '修改成功!'
              });
          } else {
            return false;
          }
        });
      },
      async checkDetailTitleRepetition(val) {
        try {
          const res = await this.$apollo.mutate({
            mutation: gql`mutation(
              $patient_id: Int!
              $treat_no: String!
              $detail_title: String!
            ){
              checkDetailTitle(
                patient_id: $patient_id
                treat_no: $treat_no
                detail_title: $detail_title
              )
            }`,
            variables: {
              patient_id: this.commonData.patientId,
              treat_no: this.commonData.treat_no,
              detail_title: val,
            },
          });
          return res.data.checkDetailTitle;
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
        checkDetailTitleRepetitionForLocal(val) {
            const findIndex = this.parNumsList.findIndex((item) => item.number === val);
            return findIndex === -1;
        },
      // 调用接口保存编号
      async modifyCosmetologyTreatDetail() {
        if (!this.hairdressingInfoData.selectedParNum.id) {
          return;
        }
        try {
          await this.$apollo.mutate({
            mutation: gql`mutation(
              $id: Int!
              $detail_title: String
            ){
              modifyCosmetologyTreatDetail(
                id: $id
                detail_title: $detail_title
              ){
                id
              }
            }`,
            variables: {
              id: this.hairdressingInfoData.selectedParNum.id,
              detail_title: this.hairdressingInfoData.selectedParNum.number,
            },
          });
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
    }
    
  }
</script>

<style lang="less" scoped>
  .number-of-treatment-wrapper{
    .content{
      margin-top: 16px;
      padding-right: 15px;
    }
  }
</style>
